const runtimeEnv = {
  basename: {
    value: "",
    osEnvName: "ROUTE_BASENAME",
    placeholder: "",
  },
  recaptchaSiteKey: {
    value: "6LcKxO8jAAAAAOy3LNYf6KY09zTEhib3uhE6oml5",
    osEnvName: "RECAPTCHA_SITE_KEY",
  },
  isTrial: {
    value: false,
    osEnvName: "IS_TRIAL",
    isFlag: true,
  },
  isDemoPortal: {
    value: false,
    osEnvName: "IS_DEMO_PORTAL",
    isFlag: true,
  },
  enableInsights: {
    value: false,
    osEnvName: "ENABLE_INSIGHTS",
    isFlag: true,
  },
  supportEmail: {
    value: "",
    osEnvName: "SUPPORT_EMAIL",
  },
};

module.exports = runtimeEnv;
